import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Button, getTestId, IconButton, Typography } from '@airtel/air-design-system';
import { View } from 'react-native';
import { LinkListItemWidget } from '../link-list-item-widget';
import { getProfileCardWidgetStyles } from './ProfileCardWidgetStyles';
export var ProfileCardWidgetComponent = props => {
  var avatarImageUrl = props.avatarImageUrl,
    onNotificationCtaActionPressMetaData = props.onNotificationCtaActionPressMetaData,
    onSettingCtaActionPressMetaData = props.onSettingCtaActionPressMetaData,
    onUserAction = props.onUserAction,
    notifierCount = props.notifierCount,
    heading = props.heading,
    subText = props.subText,
    chatCtaText = props.chatCtaText,
    onChatCtaActionPressMetaData = props.onChatCtaActionPressMetaData,
    metaInfoCtaText = props.metaInfoCtaText,
    onMetaInfoCtaActionPressMetaData = props.onMetaInfoCtaActionPressMetaData,
    leftTitle = props.leftTitle,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'ProfileCardWidget' : _props$testID,
    _props$notifierIcon = props.notifierIcon,
    notifierIcon = _props$notifierIcon === void 0 ? 'NotificationsOnIcon' : _props$notifierIcon,
    _props$settingsIcon = props.settingsIcon,
    settingsIcon = _props$settingsIcon === void 0 ? 'SettingsIcon' : _props$settingsIcon,
    style = props.style,
    imageProps = props.imageProps,
    settingsAccessibilityProps = props.settingsAccessibilityProps,
    notificationAccessibilityProps = props.notificationAccessibilityProps;
  var showNotifier = notifierCount > 0;
  var showLinkList = !!heading || !!subText || !!metaInfoCtaText;
  var showBottomContainer = !!leftTitle || !!chatCtaText;
  var profileCardWidgetStyles = getProfileCardWidgetStyles(props);
  var onChatCtaActionPressHandler = () => {
    onChatCtaActionPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onChatCtaActionPressMetaData), Object.assign({
      analyticsData: onChatCtaActionPressMetaData.analyticsData || {}
    }, props)));
  };
  var onMetaCtaActionPressHandler = () => {
    onMetaInfoCtaActionPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onMetaInfoCtaActionPressMetaData), Object.assign({
      analyticsData: onMetaInfoCtaActionPressMetaData.analyticsData || {}
    }, props)));
  };
  return _jsxs(View, Object.assign({}, getTestId(testID, 'profile_card_wrapper'), {
    style: [style]
  }, {
    children: [_jsxs(View, Object.assign({
      style: profileCardWidgetStyles.topContainer
    }, {
      children: [!!avatarImageUrl && _jsx(Avatar, Object.assign({}, getTestId(testID, 'avatar_icon'), {
        variant: "image",
        imageUrl: avatarImageUrl,
        size: "lg",
        imageProps: imageProps
      })), _jsxs(View, Object.assign({
        style: profileCardWidgetStyles.rightContainer
      }, {
        children: [_jsx(IconButton, Object.assign({}, getTestId(testID, 'notification_icon'), {
          iconName: notifierIcon,
          variant: "icon",
          noBgColor: true,
          noContainer: true,
          size: "md",
          showNotifier: showNotifier,
          notifierProps: {
            number: notifierCount,
            hasDot: notifierCount > 9
          },
          accessibilityProps: notificationAccessibilityProps,
          onPress: () => onNotificationCtaActionPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onNotificationCtaActionPressMetaData), Object.assign({
            analyticsData: onNotificationCtaActionPressMetaData.analyticsData || {}
          }, props)))
        })), _jsx(IconButton, Object.assign({}, getTestId(testID, 'setting_icon'), {
          iconName: settingsIcon,
          variant: "icon",
          noBgColor: true,
          size: "md",
          noContainer: true,
          style: profileCardWidgetStyles.settingStyle,
          accessibilityProps: settingsAccessibilityProps,
          onPress: () => onSettingCtaActionPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onSettingCtaActionPressMetaData), Object.assign({
            analyticsData: onSettingCtaActionPressMetaData.analyticsData || {}
          }, props)))
        }))]
      }))]
    })), !!showLinkList && _jsx(LinkListItemWidget, Object.assign({}, getTestId(testID, 'link_list_item_widget'), {
      noHoverEffect: true,
      noPressEffect: true,
      noHorizontalPadding: true,
      style: profileCardWidgetStyles.linkListItemWidgetStyle,
      heading: heading,
      metaInfoCtaProps: {
        size: 'md'
      },
      subHeading: subText,
      metaInfoCta: metaInfoCtaText,
      metaInfoCtaPressHandler: onMetaCtaActionPressHandler
    })), !!showBottomContainer && _jsxs(View, Object.assign({
      style: profileCardWidgetStyles.bottomContainer
    }, {
      children: [!!leftTitle && _jsx(Typography, Object.assign({
        text: leftTitle,
        type: "body-single-line-sm-bold"
      }, getTestId(testID, 'left_title'))), !!chatCtaText && _jsx(Button, Object.assign({}, getTestId(testID, 'chat_button'), {
        buttonType: "tertiary",
        size: "md",
        title: chatCtaText,
        style: profileCardWidgetStyles.chatButtonStyle,
        onPress: onChatCtaActionPressHandler
      }))]
    }))]
  }));
};
ProfileCardWidgetComponent.genericRendererKey = 'AirProfileCardWidget';